import { useState, useEffect, useContext } from "react";
import { useAuthFetch } from "../../../hooks/useAuthFetch";
import { MultiSelect } from "../../../components/menu/multiSelect";

function ReportingActivityTypeFilter({
  selected,
  onUpdate,
  onClear,
  fullWidth = false,
  labelPosition = "inset",
}) {
  const [activitiesOptions, setActivitiesOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const authFetch = useAuthFetch();

  const fetchActivityTypes = async () => {
    try {
      const response = await authFetch(
        `${process.env.REACT_APP_API_URL}/v1/reporting/activities/activity-types`
      );
      if (response.ok) {
        const data = await response.json();

        const augmentedData = data.map((activity) => ({
          ...activity,
          name: activity.type_name,
        }));

        // Clock in/out aren't real activity types (no DB row) — they're
        // surfaced from shift data. Offer each as its own filterable option so
        // the menu matches how the rows render in the table and reports.
        augmentedData.push(
          { id: "clock_in", type_name: "Clock In", name: "Clock In" },
          { id: "clock_out", type_name: "Clock Out", name: "Clock Out" }
        );

        setActivitiesOptions(augmentedData);
        setIsLoading(false);
      } else {
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchActivityTypes();
  }, []);

  return (
    <MultiSelect
      label="Activities"
      options={activitiesOptions}
      onUpdate={onUpdate}
      onClear={onClear}
      selected={selected}
      isLoading={isLoading}
      fullWidth={fullWidth}
      labelPosition={labelPosition}
    />
  );
}

export { ReportingActivityTypeFilter };
